import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  MS_LOGIN_SUCCESS,
  MS_LOGIN_FAIL,
  GOOGLE_AUTH_SUCCESS,
  GOOGLE_AUTH_FAIL,
  AUTHENTICATED_SUCCESS,
  AUTHENTICATED_FAIL,
  PASSWORD_RESET_SUCCESS,
  PASSWORD_RESET_FAIL,
  PASSWORD_RESET_CONFIRM_SUCCESS,
  PASSWORD_RESET_CONFIRM_FAIL,
  SIGNUP_SUCCESS,
  SIGNUP_FAIL,
  ACTIVATION_SUCCESS,
  ACTIVATION_FAIL,
  LOGOUT_SUCCESS,
  LOGOUT_FAIL,
  IS_TOKEN_SET
} from '../actions/types';

const initialState = {
  access: null,
  refresh: null,
  isAuthenticated: null,
  isMsAuthenticated: false,
  isSocialAuthenticated: false,
  msTokenDetails: null,
  isTokenSet: false
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case AUTHENTICATED_SUCCESS:
      return {
        ...state,
        isAuthenticated: true
        // access: payload.access_token,
        // refresh: payload.refresh_token,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        access: payload.access_token,
        refresh: payload.refresh_token
      };
    case MS_LOGIN_SUCCESS:
      localStorage.setItem('access', payload.access_token);
      localStorage.setItem('refresh', payload.refresh_token);
      localStorage.setItem('isMsAuthenticated', true);
      localStorage.setItem('isAuthenticated', true);
      localStorage.setItem('userStatus', 'active');
      document.cookie = 'X-Authorization=' + payload.access_token + '; path=/';
      return {
        ...state,
        msTokenDetails: payload,
        isMsAuthenticated: true,
        isAuthenticated: true,
        access: payload.access_token,
        refresh: payload.refresh_token
      };
    case GOOGLE_AUTH_SUCCESS:
      localStorage.setItem('access', payload.access_token);
      localStorage.setItem('refresh', payload.refresh_token);
      localStorage.setItem('isSocialAuthenticated', true);
      localStorage.setItem('isAuthenticated', true);
      localStorage.setItem('userStatus', 'active');
      document.cookie = 'X-Authorization=' + payload.access_token + '; path=/';
      return {
        ...state,
        msTokenDetails: payload,
        isSocialAuthenticated: true,
        isAuthenticated: true,
        access: payload.access_token,
        refresh: payload.refresh_token
      };
    case SIGNUP_SUCCESS:
      return {
        ...state,
        isAuthenticated: false
      };

    case AUTHENTICATED_FAIL:
    case LOGIN_FAIL:
      localStorage.setItem('isAuthenticated', false);
    case GOOGLE_AUTH_FAIL:
    case SIGNUP_FAIL:
    case LOGOUT_SUCCESS:
      // localStorage.clear()
      localStorage.setItem('isAuthenticated', null);
    // document.cookie = "X-Authorization=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    // return initialState;
    case LOGOUT_FAIL:
      // localStorage.clear()

      return {
        ...state
        // isAuthenticated: true
      };

    case IS_TOKEN_SET:
      document.cookie = 'X-Authorization=' + action.value.token_value + '; path=/';
      return {
        ...state,
        isTokenSet: action.value.is_token_set
      };

    case PASSWORD_RESET_SUCCESS:
    case PASSWORD_RESET_FAIL:
    case PASSWORD_RESET_CONFIRM_SUCCESS:
    case PASSWORD_RESET_CONFIRM_FAIL:
    case ACTIVATION_SUCCESS:
    case ACTIVATION_FAIL:
      return {
        ...state
      };
    default:
      return state;
  }
}
